import React, { Component } from 'react'
import PropTypes from 'prop-types'
import _ from 'lodash'

import hocConnect from './hocConnect'
import hocLoader from '../loader/hocLoader'

export default function (InnerComponent) {
    @hocLoader
    @hocConnect
    class HocWebSocket extends Component {
        static propTypes = {
            hideLoader: PropTypes.func.isRequired,
            locale: PropTypes.string.isRequired,
            onMessage: PropTypes.func.isRequired,
            showLoader: PropTypes.func.isRequired,
        }

        componentDidMount() {
            window.addEventListener('message', (e) => this.receiveMessage(e, this.props), false)
        }

        componentWillUnmount() {
            window.removeEventListener('message', this.receiveMessage)
        }

        receiveMessage(e, props) {
            const { onMessage } = props

            const data = _.attempt(JSON.parse.bind(null, e.data))
            if (_.isError(data) || data?.data?.newStackMessage) return null

            const type = _.get(data, 'type', null)
            const payload = _.get(data, 'data', {})

            onMessage(type, payload)
            return null
        }

        render() {
            return <InnerComponent {...this.props} />
        }
    }

    return HocWebSocket
}
